module.exports = __webpack_public_path__ + "media/images/icons/hand-right-9b5f77824c4d1558585fd9f638e24e1e.svg";